var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 1.23359C13.3 0.833594 12.7 0.833594 12.3 1.23359L7 6.53359L1.7 1.23359C1.3 0.833594 0.7 0.833594 0.3 1.23359C-0.1 1.63359 -0.1 2.23359 0.3 2.63359L5.6 7.93359L0.3 13.2336C-0.1 13.6336 -0.1 14.2336 0.3 14.6336C0.5 14.8336 0.7 14.9336 1 14.9336C1.3 14.9336 1.5 14.8336 1.7 14.6336L7 9.33359L12.3 14.6336C12.5 14.8336 12.8 14.9336 13 14.9336C13.2 14.9336 13.5 14.8336 13.7 14.6336C14.1 14.2336 14.1 13.6336 13.7 13.2336L8.4 7.93359L13.7 2.63359C14.1 2.23359 14.1 1.63359 13.7 1.23359Z",
    fill: "#B99855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.8908b4730fc1ed6b7a8cb0c59796dd2f.svg";
export { ForwardRef as ReactComponent };